export enum MajorBreakpoint {
    Mobile,
    Desktop,
}

/**
 *
 */
export function getCurrentMajorBreakpoint(): MajorBreakpoint {
    const currentBreakpoint = o_global.breakpoint.getCurrentBreakpoint();
    return currentBreakpoint === 's' || currentBreakpoint === 'm' ? MajorBreakpoint.Mobile : MajorBreakpoint.Desktop;
}

export function isMobile(): boolean {
    return getCurrentMajorBreakpoint() === MajorBreakpoint.Mobile;
}
